import {
  FETCH_PROVIDER_INVOICES_REQUEST,
  FETCH_PROVIDER_INVOICES_SUCCESS,
  FETCH_PROVIDER_INVOICES_FAILURE,
} from "./actionTypes";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export default function invoicesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROVIDER_INVOICES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PROVIDER_INVOICES_SUCCESS:
      return { ...state, loading: false, items: action.payload || [] };
    case FETCH_PROVIDER_INVOICES_FAILURE:
      return { ...state, loading: false, error: action.payload || "Failed to fetch invoices" };
    default:
      return state;
  }
}
